import { upsertInformalFeedbackRequests, upsertInformalFeedbackRequest } from 'redux/actions/informalFeedbackRequests'
import { upsertReview } from 'redux/actions/reviews'
import { upsertFetchRequest } from 'redux/actions/articleInformalFeedbackRequestsFetchRequests'
import { FetchRequestState } from 'types'
import { Store } from 'redux'
import {
  InformalFeedbackRequestsClient,
  CreateInformalFeedbackRequestInput,
  UpdateInformalFeedbackRequestInput,
  QueryOptions,
  ExternalResourceInput,
} from 'api/clients/InformalFeedbackRequestsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { QueryClient } from 'react-query'
import { informalFeedbackRequestsKeys } from 'hooks/queries/informalFeedbackRequests/informalFeedbackRequestsKeys'
import { InformalFeedbackRequestsClient as AlmanacFileInformalFeedbackRequestsClient } from 'api/clients/AlmanacFiles/InformalFeedbackRequestsClient'

// TODO: Move to original InformalFeedbackRequestsService file
export const InformalFeedbackRequestsService = {
  index: async (store: Store, almanacFile: string, options?: QueryOptions) => {
    store.dispatch(upsertFetchRequest(almanacFile, FetchRequestState.Loading))
    const res = await AlmanacFileInformalFeedbackRequestsClient.index(almanacFile, options)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertInformalFeedbackRequests(res.data.informal_feedback_requests))
      store.dispatch(upsertFetchRequest(almanacFile, FetchRequestState.Resolved))
    } else {
      store.dispatch(upsertFetchRequest(almanacFile, FetchRequestState.Rejected))
    }

    return res
  },

  show: async (store: Store, id: number, queryClient?: QueryClient) => {
    queryClient?.invalidateQueries(informalFeedbackRequestsKeys.detail(id))
    const res = await InformalFeedbackRequestsClient.show(id)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
    }

    return res
  },

  create: async (
    store: Store,
    almanacFileId: string,
    input: CreateInformalFeedbackRequestInput & { asset?: ExternalResourceInput },
    queryClient?: QueryClient,
  ) => {
    const res = await AlmanacFileInformalFeedbackRequestsClient.create(almanacFileId, input)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.forAlmanacFile(almanacFileId))
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
    }

    return res
  },

  update: async (
    store: Store,
    requestId: number,
    almanacFileId: string,
    input: UpdateInformalFeedbackRequestInput,
    queryClient?: QueryClient,
  ) => {
    const res = await InformalFeedbackRequestsClient.update(requestId, input)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.forAlmanacFile(almanacFileId))
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.detail(request.id))
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
    }

    return res
  },
}
